<template>
    <div class="c-tr">
        <div class="c-tw w-names">
            <div class="c-td c-promos-image pr-2">
                <div class="c-fig c-fig--promos">
                    <img :src="product.dict_product.image.urls.small" alt class="c-fig__img" />
                </div>
            </div>
            <div class="c-td">
                <p class="text-primary font-weight-medium mb-0">{{product.dict_product.name}}</p>
                <p class="typo--sm mb-0">EAN: {{product.dict_product.ean}}</p>
            </div>
        </div>
        <div class="c-tw w-numbers products-list-numbers" :class="{ 'c-tw w-data' : isPromomix1, 'w-data' : isPromomix }">
            <div class="c-td" :class="{ 'text-right' : isPromomix1, 'w-refund' : isPromomix }" v-if="promoType !== 'Promo::SalesTarget'">
                <span class="typo-label d-inline d-md-none d-md-none mr-2 mr-md-0">Zwrot netto</span>
                <span
                    v-if="product.refund_total && product.refund_total[1]"
                    class="d-block d-md-inline-block typo-number"
                >{{ product.refund_total[0].toFixed(2) }} - {{ product.refund_total[1] | currency }}</span>
                <span
                    class="d-block d-md-inline-block typo-number"
                    v-else-if="product.refund_total"
                >{{ product.refund_total[0] | currency }}</span>
                <span
                    class="d-block d-md-inline-block typo-number"
                    v-else-if="product.amount_of_refund"
                >{{ product.amount_of_refund | currency }}</span>
                <span class="d-block d-md-inline-block typo-number" v-else>---</span>
            </div>
            <div class="c-td" v-if="!isPromomix1 && promoType !== 'Promo::SalesTarget'" :class="{ 'w-points' : isPromomix }">
                <span
                    class="typo-label d-inline d-md-none"
                >{{ isPromomix ? 'Punkty' : 'Min. liczba' }}</span>
                <span class="d-block d-md-inline-block typo-number">{{ minAmount }}</span>
            </div>
            <div
                class="c-td"
                v-if="product.maximum_promotional_price !== undefined && product.maximum_promotional_price !== null && !productTriggers"
            >
                <span class="typo-label d-inline d-md-none">Max. cena</span>
                <span
                    v-if="product.maximum_promotional_price"
                    class="d-block d-md-inline-block typo-number"
                >{{ product.maximum_promotional_price | currency }}</span>
                <span v-else class="d-block d-md-inline-block typo-number">---</span>
            </div>
            <div
                class="c-td"
                v-if="product.percentage_discount"
            >
                <span class="typo-label d-inline d-md-none">Rabat</span>
                <span
                    v-if="product.percentage_discount"
                    class="d-block d-md-inline-block typo-number"
                >{{ product.percentage_discount }}%</span>
                <span v-else class="d-block d-md-inline-block typo-number">---</span>
            </div>
        </div>
        <!-- TODO : editPrice -->
        <!-- TODO : set .w-names width to 40% in products.scss -->
        <!-- <div class="c-td w-actions">
            <div v-show="editPrice" class="input-currency" style="width: 12rem">
                <input class="form-control" type="text" v-model="promoPrice" @blur="editPrice = false" />
            </div>
            <button
                v-show="!editPrice"
                @click="changePrice"
                class="btn btn-outline-custom c-promos-btn"
            >
                <span class="mr-auto font-weight-normal">{{promoPrice}} zł</span>
                <a-icon icon="Edit" :iconClass="'text-secondary'" />
            </button>
        </div>-->
    </div>
</template>

<script>
export default {
    data() {
        return {
            editPrice: false,
            promoPrice: '1.95 - 2.50'
        }
    },
    props: {
        product: {
            type: Object,
            required: true
        },
        requiredWeight: {
            type: String,
            required: false
        },
        productTriggers: {
            type: Boolean,
            default: false
        },
        isPromomix: {
            type: Boolean,
            default: false
        },
        isPromomix1: {
            type: Boolean,
            default: false
        },
        promoType: {
            type: String,
            required: false
        }
    },
    methods: {
        changePrice($event) {
            this.promoPrice = ''
            this.editPrice = true
            // set focus to input
            this.$nextTick(() => {
                this.$el.querySelector('input').focus()
            })
        }
    },
    computed: {
        minAmount() {
            if (this.product.count) {
                return this.product.count
            } else if (this.isPromomix) {
                return this.product.weight
            } else {
                return '---'
            }
        }
    }
}
</script>